import { useText } from '../../shared/i18n/I18nProvider';

export default function AuthLoginLoadingShell({ loginTarget = 'student', reserveSecondaryAction = false }) {
  const t = useText();
  const target = ['admin', 'parent', 'student'].includes(loginTarget) ? loginTarget : 'student';

  return (
    <main className="layout auth-login-layout">
      <div className={`login-shell login-shell--${target}`}>
        <section className="login-wireframe-card" aria-busy="true">
          <section className="login-wireframe-brand" aria-hidden="true" />
          <section className="login-wireframe-form-panel" aria-label={t('common.loading.workspace')}>
            <div className="login-wireframe-form-wrap login-wireframe-loading-form" aria-hidden="true">
              <div className="login-wireframe-loading-copy" />
              <div className="login-wireframe-loading-input" />
              <div className="login-wireframe-loading-input" />
              <div className="login-wireframe-loading-link" />
              <div className="login-wireframe-loading-submit" />
              {reserveSecondaryAction ? <div className="login-wireframe-loading-secondary-cta" /> : null}
              <div className="login-wireframe-loading-footer" />
            </div>
          </section>
        </section>
      </div>
    </main>
  );
}
